//get Trailer
export const GET_ADBANNER = "GET_ADBANNER";

//Insert Trailer
export const INSERT_ADBANNER = "INSERT_ADBANNER";

//Update Trailer
export const CHANGE_ADBANNER_STATUS = "CHANGE_ADBANNER_STATUS";

//Delete Trailer
export const DELETE_ADBANNER = "DELETE_ADBANNER";

//Open and Close Dialog
export const OPEN_ADBANNER_DIALOG = "OPEN_ADBANNER_DIALOG";
export const CLOSE_ADBANNER_DIALOG = "CLOSE_ADBANNER_DIALOG";

//toast
export const OPEN_ADBANNER_TOAST = "OPEN_ADBANNER_TOAST";
export const CLOSE_ADBANNER_TOAST = "CLOSE_ADBANNER_TOAST";
